module.exports = __webpack_public_path__ + "static/media/buildingConstruction43.4525f6e4.jpg";